import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { selectMovie } from '../reducers/movies/selectors'
import { MediaItemData } from '../models/mediaItemData'
import { useEffect } from 'react'
import { loadMovies } from '../reducers/movies/dispatchers'

export const useMovieParam = (): MediaItemData => {
  const dispatch = useDispatch()
  const { videoId } = useParams<{ videoId: string }>()

  useEffect(() => {
    void dispatch(loadMovies())
  }, [dispatch])

  return useSelector(selectMovie(+videoId))
}
